/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React, {useContext, useEffect, useState} from 'react';
import {AppContext} from '../misc/appContext';
import Account from '../../models/accountModel';
import {ResponseData} from '@dvrd/dvr-controls';
import {createErrorMessage} from '../../util/utils';
import TrackingDecision from './trackingDecision';
import {showDialog, showSnackbar} from '@dvrd/dvr-controls';
import {useTranslation} from 'react-i18next';

const flexKey = 'use_no_reply_tracking';

export default function TrackingDecisionController() {
    const context = useContext(AppContext);
    const {t} = useTranslation();
    const [active, setActive] = useState(false);
    const [loading, setLoading] = useState(false);

    function onActivate() {
        const {account} = context.accountContext;
        if (!account) return;
        if (!account.settings?.enableMailTracking) return;
        if (account.getFlex(flexKey) !== undefined) return;
        setActive(true);
    }

    function onClose() {
        setActive(false);
    }

    function onDecide(useTracking: boolean) {
        return function () {
            const {account} = context.accountContext;
            if (!account) return;
            setLoading(true);
            account.setFlex(flexKey, useTracking);
            account.update(
                undefined,
                undefined,
                undefined,
                (account: Account, success: boolean, data: ResponseData) => {
                    setLoading(false);
                    if (success) {
                        showSnackbar(t('tracking.saved', 'Je keuze is opgeslagen'));
                        onClose();
                    } else
                        showDialog(
                            createErrorMessage(
                                data.message ??
                                    t('tracking.saveFailedMessage', 'Het opslaan van je keuze is niet gelukt.')
                            ),
                            t('tracking.saveFailed', 'Opslaan mislukt')
                        );
                }
            );
        };
    }

    useEffect(() => {
        onActivate();
    }, [context.accountContext.account]);

    return <TrackingDecision onDecide={onDecide} onClose={onClose} active={active} loading={loading} />;
}
